import React, { ReactNode, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { EModalSize } from '../enum/modal';
import classes from './modal.module.css';
import CC from '../scripts/combine-classes';

type ModalProps = {
  children: ReactNode,
  onClose: () => void,
  width?: EModalSize,
  height?: EModalSize,
}

const Modal = ({
  children,
  onClose,
  width = EModalSize.md,
  height = EModalSize.md,
}: ModalProps) => {
  const modalRef = useRef<HTMLDivElement>(null);
  
  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      console.warn('No close method');
    }
  };

  useEffect(() => {
    const clickHandler = (event: MouseEvent) => {
      if (event.target !== null) {
        const target: HTMLElement = event.target as HTMLElement;
        if (!(modalRef.current && modalRef.current.contains(target))) {
          handleClose();
        }
      }
    }

    const pressHandler = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handleClose();
      }
    }

    document.body.style.overflow = 'hidden';
    document.addEventListener('mousedown', clickHandler);
    document.addEventListener('keydown', pressHandler);

    return () => {
      document.body.style.overflow = 'auto';
      document.removeEventListener('mousedown', clickHandler);
      document.removeEventListener('keydown', pressHandler);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return createPortal(
    <div
      id="modalContainer"
      className={classes.modalContainer}
    >
      <div
        ref={modalRef}
        id="modal"
        className={CC(
          classes.modal,
          classes[`width_${width}`],
          classes[`height_${height}`],
        )}
      >
        <button
          className={classes.close}
          onClick={handleClose}
        >
          X
        </button>
        {children}
      </div>
    </div>,
    document.body
  );
};

export default Modal;
